// Others
import axiosClient from './axiosClient';
import { urlApiRole } from '~/utils/constants/apis';
import { IBodyUpdate, IQueryParamBase } from '~/utils/interface/common';
import { IFormRole, IRole, IRoleDetail } from '~/utils/interface/role';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';

const roleApi = {
  getListRole: (params: IQueryParamBase) => {
    const url = urlApiRole.getListRole;
    return axiosClient.get<IBaseResponse<IListDataResponse<IRole[]>>>(url, { params });
  },

  getDetailRole: (id: string) => {
    const url = urlApiRole.getDetailRole(id);
    return axiosClient.get<IBaseResponse<IRoleDetail>>(url);
  },

  createRole: (body: IFormRole) => {
    const url = urlApiRole.createRole;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  updateRole: (params: IBodyUpdate<IFormRole>) => {
    const { id, body } = params;
    const url = urlApiRole.updateRole(id);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  deleteRole: (id: string) => {
    const url = urlApiRole.deleteRole(id);
    return axiosClient.delete<IBaseResponse>(url);
  },
};

export default roleApi;
